import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FcSearchManyInputModule } from '../../base/fc-search-many-input/fc-search-many-input.module';
import { FcCompaniesInputComponent } from './fc-companies-input.component';


@NgModule({
  declarations: [
    FcCompaniesInputComponent
  ],
  imports: [
    FcSearchManyInputModule,
    TranslateModule
  ],
  exports: [
    FcCompaniesInputComponent
  ]
})
export class FcCompaniesInputModule {}
